// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    api,
    IApiResponse,
    IPaginateApiResponse,
} from 'common/api/resources/Response';
import {
    IAvailableIpBlock,
    IFailoverDomainCreateRequest,
    IFailoverDomainDetailResponse,
    IFailoverDomainPatchRequest,
    IFailoverDomainResponse,
} from 'common/api/resources/FailoverDomain/model';
import { IPaginatedWithSearch } from 'common/api/resources/Request/request';
import { QueryBuilder } from 'common/api/resources/Request/QueryBuilder';

export const failoverDomains = {
    list: (params?: IPaginatedWithSearch) => api.get<IPaginateApiResponse<IFailoverDomainResponse[]>>(
        'failover_domains',
        { params: new QueryBuilder(params).build() }
    ),
    create: (data: IFailoverDomainCreateRequest) => api.post<IApiResponse<IFailoverDomainResponse>>(
        'failover_domains',
        data
    ),
    item: (id: number) => api.get<IApiResponse<IFailoverDomainDetailResponse>>(
        `failover_domains/${id}`
    ),
    patch: (id: number, data: IFailoverDomainPatchRequest) => api.patch<IApiResponse<IFailoverDomainResponse>>(
        `failover_domains/${id}`,
        data
    ),
    remove: (id: number) => api.delete(
        `failover_domains/${id}`
    ),
    availableIpBlocks: (params: {
        compute_resource_ids: number[];
        failover_domain_id?: number;
        filters?: { search?: string };
        page?: number;
    }) => api.get<IPaginateApiResponse<IAvailableIpBlock[]>>(
        'failover_domains/available_ip_blocks',
        {
            params: {
                compute_resource_ids: params.compute_resource_ids,
                ...(params.failover_domain_id !== undefined
                    ? { failover_domain_id: params.failover_domain_id }
                    : {}),
                ...new QueryBuilder({ page: params.page, filters: params.filters }).build(),
            },
        }
    ),
};
